/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractQuoteDto } from './ContractQuoteDto';
import {
    ContractQuoteDtoFromJSON,
    ContractQuoteDtoFromJSONTyped,
    ContractQuoteDtoToJSON,
    ContractQuoteDtoToJSONTyped,
} from './ContractQuoteDto';

/**
 * 
 * @export
 * @interface GetContractQuotesResponseDto
 */
export interface GetContractQuotesResponseDto {
    /**
     * 
     * @type {Array<ContractQuoteDto>}
     * @memberof GetContractQuotesResponseDto
     */
    quotes: Array<ContractQuoteDto>;
}

/**
 * Check if a given object implements the GetContractQuotesResponseDto interface.
 */
export function instanceOfGetContractQuotesResponseDto(value: object): value is GetContractQuotesResponseDto {
    if (!('quotes' in value) || value['quotes'] === undefined) return false;
    return true;
}

export function GetContractQuotesResponseDtoFromJSON(json: any): GetContractQuotesResponseDto {
    return GetContractQuotesResponseDtoFromJSONTyped(json, false);
}

export function GetContractQuotesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractQuotesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quotes': ((json['quotes'] as Array<any>).map(ContractQuoteDtoFromJSON)),
    };
}

export function GetContractQuotesResponseDtoToJSON(json: any): GetContractQuotesResponseDto {
    return GetContractQuotesResponseDtoToJSONTyped(json, false);
}

export function GetContractQuotesResponseDtoToJSONTyped(value?: GetContractQuotesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quotes': ((value['quotes'] as Array<any>).map(ContractQuoteDtoToJSON)),
    };
}

